import type {UploadFileDataTypes, UserMediaType, UserMediaVOResponse} from '@Libraries/user-media-library';
import {MultiMediaUploadSource, uploadImages, uploadVideos, userMediaVOToElementData} from '@Libraries/user-media-library';
import isArray from 'lodash/isArray';
import {RecorderMediaType} from '@Panels/record-image-and-video-panel/record-image-and-video.types';
import {isAndroid, isIOS} from 'react-device-detect';
import {MOBILE_MODAL_WIDTH_THRESHOLD} from '@Components/modal';
import type {ElementData} from '@Libraries/add-media-library';

interface ImageAndVideoUploadData {
  mediaType: RecorderMediaType;
  fileToUpload: File;
}

interface ImageAndVideoUploadDataOptions {
  mirror?: boolean;
  collectionId?: string;
}

export const onUploadImageAndVideo = (type: UserMediaType, data: UserMediaVOResponse[] | UserMediaVOResponse, onAddCallback: (item: ElementData) => void): void => {
  if (!isArray(data)) {
    const itemData = userMediaVOToElementData(type, data);
    onAddCallback(itemData);
  }
};

export const handleImageOrVideoUpload = (
  data: ImageAndVideoUploadData,
  onUpload: (type: UserMediaType, data: UserMediaVOResponse[] | UserMediaVOResponse) => void,
  opts: ImageAndVideoUploadDataOptions = {
    mirror: false,
    collectionId: '',
  }
): void => {
  if (data.mediaType === RecorderMediaType.IMAGE) {
    void uploadImages(
      [data.fileToUpload],
      {onFileUpload: onUpload as (type: UserMediaType, data: UploadFileDataTypes) => void, onUploadError: () => {}},
      {
        collectionId: opts.collectionId ?? '',
        uploadSrc: MultiMediaUploadSource.UPLOAD,
        addInBulk: false,
        uploadVectors: true,
        mirror: opts.mirror,
      }
    );
  } else if (data.mediaType === RecorderMediaType.VIDEO) {
    void uploadVideos([data.fileToUpload], onUpload as (type: UserMediaType, data: UploadFileDataTypes) => void, () => {}, {
      collectionId: opts.collectionId ?? '',
      uploadSrc: MultiMediaUploadSource.UPLOAD,
      addInBulk: false,
      mirror: opts.mirror,
    });
  }
};

export const isMobileSize = (windowWidth: number): boolean => {
  return windowWidth < MOBILE_MODAL_WIDTH_THRESHOLD;
};

export const isOpenCustomImageAndVideoRecorder = (): boolean => {
  return !isAndroid;
};

export const isOpenCustomImageAndVideoRecorderSmall = (windowWidth: number): boolean => {
  return (!isAndroid && windowWidth <= MOBILE_MODAL_WIDTH_THRESHOLD) || (isIOS && windowWidth >= MOBILE_MODAL_WIDTH_THRESHOLD);
};

export const getSupportedVideoMimeType = (): 'video/webm' | 'video/mp4' | undefined => {
  if (MediaRecorder.isTypeSupported('video/mp4')) {
    return 'video/mp4';
  }
  if (MediaRecorder.isTypeSupported('video/webm')) {
    return 'video/webm';
  }

  return undefined;
};
